<template>
  <div>
    <b-row>
      <b-col sm="12">
        <CheckboxGroup title="Marque as opções (se houver)" :stacked="true" :options="[
          { text: 'Lançar Condição de Pagamento no Financeiro?', value: 'registerInFinance' },
        ]" v-model="optionsSelected" />
      </b-col>
    </b-row>
    <div class="text-center">

      <Button _key="btnRentAccept" title="Aprovar" type="success" size="medium" :clicked="update" />
    </div>
  </div>
</template>
<script>

import Button from "@nixweb/nixloc-ui/src/component/forms/Button.vue";
import CheckboxGroup from "@nixweb/nixloc-ui/src/component/forms/CheckboxGroup";

import { mapMutations, mapActions } from "vuex";

export default {
  name: "RentAccept",
  props: {
    rentId: String,
  },
  components: {
    Button, CheckboxGroup
  },
  data() {
    return {
      optionsSelected: [],
      urlUpdate: "/api/v1/rental/rent/accept"
    };
  },
  methods: {
    ...mapActions("generic", ["putApi"]),
    ...mapMutations("generic", ["addEvent", "hideModal", "removeLoading"]),
    update() {
      let params = { url: this.urlUpdate, obj: { rentId: this.rentId, options: this.optionsSelected } };
      this.putApi(params).then((response) => {
        if (response.success) {
          this.addEvent({ name: "rentAccepted" });
          this.hideModal();
        }
        this.removeLoading(["btnRentAccept"]);
      });
    },
  },
};
</script>